import React from 'react';

interface Props {
    option: string;
    searchTerm: string;
    passedProps: React.HTMLAttributes<HTMLElement>;
}
export function AutocompleteResult(props: Props) {
    const { option, searchTerm, passedProps } = props;

    const parts = option.split(new RegExp(`(${searchTerm.toLowerCase()})`, 'gi'));

    return (
        <li {...passedProps}>
            <span>
                {parts.map((part, i) =>
                    // only match the string starting with the match
                    <span key={i} style={i === 1 && part.toLowerCase() === searchTerm.toLowerCase() ? {} : { fontWeight: 'bold' }}>
                        {part}
                    </span>,
                )}
            </span>
        </li>
    );
}